// extracted by mini-css-extract-plugin
module.exports = {"text":"_85Hj2C"};